import { useMutation } from '@apollo/client';

import { UpdateUserMaxSuperLikesInput } from '../../apollo/__generated__/graphql';
import { UPDATE_USER_MAX_SUPER_LIKES } from '../graphql/mutation/updateUserMaxSuperLikesMutation.graphql';

export const useUpdateUserMaxSuperLikesMutation = () => {
  const [mutate] = useMutation(UPDATE_USER_MAX_SUPER_LIKES);

  const updateMaxSuperLikes = (
    updateUserMaxSuperLikesInput: UpdateUserMaxSuperLikesInput,
  ) => {
    mutate({
      variables: {
        updateUserMaxSuperLikesInput,
        eventId: updateUserMaxSuperLikesInput.eventId,
      },
    });
  };

  return { updateMaxSuperLikes };
};
